module.exports = __webpack_public_path__ + "static/img/pro_tab8.f1bff43.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/pro_tab8.jpg
// module id = ZnK5
// module chunks = 171